// extracted by mini-css-extract-plugin
module.exports = {"component":"AboutUs_component__1ZNOC","text":"AboutUs_text__1vmtb","short":"AboutUs_short__3SWOG","long":"AboutUs_long__pLFOw","image":"AboutUs_image__2WBSw"};